import type { AnalyzeRequest, AnalyzeResponse } from "@brutally/shared";
import { API_BASE } from "../env.js";

export async function analyze(req: AnalyzeRequest): Promise<AnalyzeResponse> {
  try {
    const res = await fetch(`${API_BASE}/api/analyze`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(req),
      credentials: "include"
    });
    const json = (await res.json()) as AnalyzeResponse;
    return json;
  } catch (err) {
    const message = err instanceof Error ? err.message : "Network error";
    return { ok: false, code: "MODEL_ERROR", message };
  }
}
